// ------------------------------
// 🌐 IMPORTACIONES
// ------------------------------
import { useEffect, useState, useRef } from "react";
import '@fontsource/montserrat';
import '@fontsource/montserrat/700.css';
import './styles/App.css';
import './styles/App-page-1.css'
import './styles/App-page-2.css'
import './styles/App-page-3.css'
import './styles/App-page-4.css'
import './styles/App-page-5.css'
import './styles/App-page-6.css'
import './styles/App-page-7.css'
import './styles/App-page-8.css'
import './styles/App-page-9.css'
import './styles/App.mobile.css'

import Header from "./Components/Header";
import Footer from "./Components/Footer";
import ParallelogramRow from "./Components/ParallelogramRow";
import Title from "./Components/Title";
import { page5_items, page7_items } from "./constants";
import FeaturesText from "./Components/FeaturesText";
import FeaturesSubtitle from "./Components/FeaturesSubtitle"
import MessageInput from "./Components/MessageInput";
import Text from "./Components/Text";
import CustomCarousel from "./Components/CustomCarousel";


export function useScrollReveal(targetSelector, options = { threshold: 0.5 }) {
  useEffect(() => {
    const elements = document.querySelectorAll(targetSelector);

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add("visible");
        } else {
          // cuando sale del viewport, quitamos la clase
          entry.target.classList.remove("visible");
        }
      });
    }, options);

    elements.forEach(el => observer.observe(el));

    return () => {
      elements.forEach(el => observer.unobserve(el));
    };
  }, [targetSelector, options]);
}


// ------------------------------
// 🛠 FUNCIONES (manejadores de estado)
// ------------------------------
function App() {
  const page1Ref = useRef(null);
  const [comments, setComments] = useState(null);

  // ✅ Detección de dispositivo (simple)
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth <= 768);
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);


  useScrollReveal(".scroll-reveal", { threshold: 0.3 });

  const slides = [
    <div className="App-page App-page-1" ref={page1Ref}>
      <img className="App-graphic-bar scroll-reveal" src="/page-1/1.png" id="App-page-1-1" />
      <img className="App-graphic-bar scroll-reveal" src="/page-1/2.png" id="App-page-1-2" />
      <img
        src={isMobile ? "/page-1/page-1-image-mobile.png" : "/page-1/page-1-image.png"}
        className="App-page-1-image"
        alt="Joy Group portada"
      />


    </div>];

  const handleSendEmail = (text) => {
    if (!text?.length) {
      alert("Por favor, ingrese un mensaje");
      return;
    }

    const email = "diego@joygroup.io";
    const subject = "Mensaje desde la web";
    const body = encodeURIComponent(text);

    const mailtoLink = `mailto:${email}?subject=${encodeURIComponent(subject)}&body=${body}`;

    // Abrir en una nueva pestaña
    window.open(mailtoLink, "_blank");
  };

  useEffect(() => {
    window.addEventListener('wheel', function (e) {
      if (e.ctrlKey) {
        e.preventDefault();
      }
    }, { passive: false });

    window.addEventListener('keydown', function (e) {
      if ((e.ctrlKey || e.metaKey) && (e.key === '+' || e.key === '-' || e.key === '=')) {
        e.preventDefault();
      }
    });

  }, [])

  return (
    <div className="App">
      {/* --- Header */}
      <Header page1Ref={page1Ref} />

      {/* --- Page 1 */}
      <CustomCarousel
        items={slides}
        autoPlay={false}
        autoPlayInterval={3000}
      />;

      {/* --- Page 2 */}
      <div className="App-page App-page-2">
        <img className="App-graphic-bar scroll-reveal" src="/page-2/page-2-bar-green.png" id="App-page-2-bar-green" />

        <img className="App-graphic-bar scroll-reveal" src="/page-2/page-2-bar-grey.png" id="App-page-2-bar-grey" />

        <img className="App-graphic-bar scroll-reveal" src="/page-2/page-2-bar-white-cropped.png" id="App-page-2-bar-white-cropped" />
        <img className="App-graphic-bar scroll-reveal" src="/page-2/page-2-bar-white.png" id="App-page-2-bar-white" />

        <img src="/page-2/page-2-image.png" className='App-page-2-image' />
        <div id="App-page-2-title-wrapper">
          <Title>
            una agencia<br />de marketing<br />deportivo<br />y organización<br />de eventos
          </Title>
        </div>
      </div>

      {/* --- Page 3 */}
      <div className="App-page">


        <img src="/page-3/page-3-image.png" className='App-page-3-image' />
        <div className="App-page-3-right-text-container">
          <img className="App-graphic-bar scroll-reveal" src="/page-3/page-3-bar-black.png" id="App-page-3-bar-black" />
          <img className="App-graphic-bar scroll-reveal" src="/page-3/page-3-bar-green.png" id="App-page-3-bar-green" />
          <img className="App-graphic-bar scroll-reveal" src="/page-3/page-3-bar-grey.png" id="App-page-3-bar-grey" />
          <img className="App-graphic-bar scroll-reveal" src="/page-3/page-3-bar-white-triangle.png" id="App-page-3-bar-white-triangle" />
          <img className="App-graphic-bar scroll-reveal" src="/page-3/page-3-bar-white.png" id="App-page-3-bar-white" />

          <div id="App-page-3-title-wrapper">
            <Title>¿Qué<br />hacemos?</Title>
          </div>

          <div id="App-page-3-features-wrapper">
            <FeaturesText>
              <FeaturesSubtitle>
                Nos especializamos en el desarrollo de<br />proyectos deportivos integrales
              </FeaturesSubtitle>
              <Text>Organización de eventos y torneos deportivos.</Text>
              <Text>Comercialización y negociación de derechos.</Text>
              <Text>Desarrollo de experiencias innovadoras para marcas,<br />atletas y audiencias.</Text>
            </FeaturesText>
          </div>
        </div>
      </div>

      {/* --- Page 4 */}
      <div className="App-page">


        <img src="/page-4/page-4-image.png" className='App-page-4-image' />
        <div className="App-page-4-right-text-container">
          <img className="App-graphic-bar scroll-reveal" src="/page-4/page-4-bar-grey-right.png" id="App-page-4-bar-grey-right" />

          <div id="App-page-4-title-wrapper">
            <Title>nuestro adn:</Title>
          </div>

          <FeaturesText>
            <FeaturesSubtitle>CREATIVIDAD</FeaturesSubtitle>
            <Text>Herencia natural de Joy Group, aplicada hoy al deporte para desarrollar campañas, experiencias y contenidos únicos.</Text>
          </FeaturesText>

          <FeaturesText>
            <FeaturesSubtitle>INNOVACIÓN Y TECNOLOGÍA</FeaturesSubtitle>
            <Text>Creemos en el uso estratégico de datos, plataformas, streaming, fan engagement y modelos digitales para transformar la industria.</Text>
          </FeaturesText>

          <FeaturesText>
            <FeaturesSubtitle>RIGOR PROFESIONAL</FeaturesSubtitle>
            <Text>Operamos con estándares de calidad, transparencia y cumplimiento<br />propio de los grandes del sector.</Text>
          </FeaturesText>

        </div>
      </div>

      {/* --- Page 5 */}
      <div className="App-page">
        <img className="App-graphic-bar scroll-reveal" src="/page-5/page-5-bar-grey-left.png" id="App-page-5-bar-grey-left" />
        <img className="App-graphic-bar scroll-reveal" src="/page-5/page-5-bar-grey-right.png" id="App-page-5-bar-grey-right" />
        <img className="App-graphic-bar scroll-reveal" src="/page-5/page-5-bar-white.png" id="App-page-5-bar-white" />
        <img className="App-graphic-bar scroll-reveal" src="/page-5/page-5-bar-green-small.png" id="App-page-5-bar-green-small" />
        <img className="App-graphic-bar scroll-reveal" src="/page-5/page-5-bar-green-large.png" id="App-page-5-bar-green-large" />

        <div className="App-page-content">
          <div className="App-page-5-content-top">
            <img src="/page-5/page-5-image.png" className='App-page-5-image' />
            <div id="App-page-5-title-wrapper">
              <Title>nuestras unidades<br />de servicio</Title>
            </div>
          </div>

          <div id="App-page-5-parallelogram-wrapper">
            <ParallelogramRow items={page5_items} />
          </div>
        </div>
      </div>

      {/* --- Page 6 */}
      <div className="App-page">
        <img className="App-graphic-bar scroll-reveal" src="/page-6/page-6-bar-grey.png" id="App-page-6-bar-grey" />
        {/*<img className="App-graphic-bar scroll-reveal" src="/page-6/page-6-bar-green-small.png" id="App-page-6-bar-green-small" />*/}
        <img className="App-graphic-bar scroll-reveal" src="/page-6/page-6-bar-green-large.png" id="App-page-6-bar-green-large" />
        <img className="App-graphic-bar scroll-reveal" src="/page-6/page-6-bar-grey-right.png" id="App-page-6-bar-grey-right" />

        <img src="/page-6/page-6-image.png" className='App-page-6-image' />
        <div className="App-page-6-right-text-container">

          <Title>nuestro diferencial</Title>

          <FeaturesText>
            <FeaturesSubtitle>RED DE CONTACTOS EN TODO EL ECOSISTEMA DEPORTIVO</FeaturesSubtitle>
            <Text>(clubes, federaciones, medios y sponsors)</Text>
          </FeaturesText>

          <FeaturesText>
            <FeaturesSubtitle>KNOW-HOW INTERNACIONAL</FeaturesSubtitle>
            <Text>En marketing, TV rights, sponsoreo y producción.</Text>
          </FeaturesText>

          <FeaturesText>
            <FeaturesSubtitle>CAPACIDAD COMPROBADA PARA EJECUTAR EVENTOS DE ALTA CONVOCATORIA</FeaturesSubtitle>
            <Text>En deportes como: Fútbol, Rugby, Tenis, Básquetbol, Deportes Ecuestres y más.</Text>
          </FeaturesText>

          <FeaturesText>
            <FeaturesSubtitle>MIRADA ESTRATÉGICA Y COMERCIAL</FeaturesSubtitle>
            <Text>Enfocada en resultados.</Text>
          </FeaturesText>

        </div>
      </div>

      {/* --- Page 7 */}
      <div className="App-page">
        <img className="App-graphic-bar scroll-reveal" src="/page-7/page-7-bar-grey.png" id="App-page-7-bar-grey" />
        <img className="App-graphic-bar scroll-reveal" src="/page-7/page-7-bar-green-small.png" id="App-page-7-bar-green-small" />

        <div className="App-page-7-content">
          <div className="App-page-7-content-top">
            <img src="/page-7/page-7-image.png" className='App-page-7-image' />

            <div id="App-page-7-title-wrapper">
              <Title>nuestra industria<br />está en modo leyenda,<br />aprovechémoslo</Title>
            </div>

          </div>
          <div id="App-page-7-parallelogram-wrapper">
            <ParallelogramRow items={page7_items} width={320} />
          </div>
        </div>
      </div>

      {/* --- Page 8 */}
      <div className="App-page-8">
        <img className="App-graphic-bar scroll-reveal" src="/page-8/bar-grey.png" id="App-page-8-bar-grey" />
        <img className="App-graphic-bar scroll-reveal" src="/page-8/bar-white.png" id="App-page-8-bar-white" />

        <div className="App-page-8-content">

          <div id="App-page-8-title-wrapper">
            <Title>casos de éxito recientes</Title>
          </div>

          <div className="App-page-8-images">

            <div className='App-page-image-with-text'>
              <img src="/page-8/page-8-image-1.png" />
              <FeaturesText>
                <FeaturesSubtitle>Rugby Sevens<br />Viña del Mar</FeaturesSubtitle>
                <Text>Y Finales<br />del Rugby Chileno</Text>
              </FeaturesText>
            </div>

            <div className='App-page-image-with-text'>
              <img src="/page-8/page-8-image-2.png" />
              <FeaturesText>
                <FeaturesSubtitle>Eventos diversos</FeaturesSubtitle>
                <Text>Eventos ecuestres,<br />torneos de verano<br />y partidos internacionales</Text>
              </FeaturesText>
            </div>

            <div className='App-page-image-with-text'>
              <img src="/page-8/page-8-image-3.png" />
              <FeaturesText>
                <FeaturesSubtitle>Proyectos<br />de inversión</FeaturesSubtitle>
                <Text>Y gobernanza<br />en clubes deportivos</Text>
              </FeaturesText>
            </div>
          </div>
        </div>
      </div>

      {/* --- Page 9 */}
      <div className="App-page-9">

        <div className="App-page-9-content">
          <div className="App-page-9-left-container">
            <img src="/page-9/page-9-image.png" id='App-page-9-image' />
          </div>

          <div className="App-page-9-right-container">
            <Title>¿armamos equipo?</Title>

            <MessageInput
              title="Empecemos por un mensaje"
              onChangeMessage={(ev) => setComments(ev.target.value)}
              onClickSend={() => handleSendEmail(comments)}
              disabled={!comments?.length}
            />
            <img className="App-graphic-bar scroll-reveal" src="/page-9/bar-grey.png" id="App-page-9-bar-grey" />
            <img className="App-graphic-bar scroll-reveal" src="/page-9/bar-green.png" id="App-page-9-bar-green" />

          </div>
        </div>


      </div>
      <Footer

      />
    </div>
  );
}

export default App;
